import { Circle, Clock, Ban, CheckCircle2, AlertTriangle, CalendarDays } from "lucide-react";

// Centralised task status configuration — use this everywhere task statuses appear
export const TASK_STATUS_CONFIG = {
  "Not Started": { icon: Circle, color: "text-slate-400", bg: "bg-slate-50 border-slate-200", badgeBg: "bg-slate-100 text-slate-600" },
  "In Progress": { icon: Clock, color: "text-blue-500", bg: "bg-blue-50 border-blue-200", badgeBg: "bg-blue-100 text-blue-700" },
  "Blocked": { icon: Ban, color: "text-orange-500", bg: "bg-orange-50 border-orange-200", badgeBg: "bg-orange-100 text-orange-700" },
  "Done": { icon: CheckCircle2, color: "text-emerald-500", bg: "bg-emerald-50 border-emerald-200", badgeBg: "bg-emerald-100 text-emerald-700" },
};

// Date-based urgency styles (applied on top of status)
export const TASK_URGENCY = {
  overdue: { bg: "bg-red-50/50 border-red-200", text: "text-red-500 font-medium", filterActive: "bg-red-100 border-red-300 text-red-700", filterInactive: "bg-red-50 border-red-200 text-red-600" },
  dueToday: { bg: "bg-amber-50/30 border-amber-200", text: "text-amber-600 font-medium", filterActive: "bg-amber-100 border-amber-300 text-amber-700", filterInactive: "bg-amber-50 border-amber-200 text-amber-600" },
  normal: { bg: "bg-white border-slate-100 hover:border-slate-200", text: "", filterActive: "bg-blue-100 border-blue-300 text-blue-700", filterInactive: "bg-slate-50 border-slate-200 text-slate-500" },
};

export const TASK_CATEGORY_COLORS = {
  "Delivery": "bg-blue-100 text-blue-700",
  "Proposal": "bg-purple-100 text-purple-700",
  "Follow-up": "bg-amber-100 text-amber-700",
  "Ops": "bg-slate-100 text-slate-700",
  "Finance": "bg-emerald-100 text-emerald-700",
};
